import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/usuarios/roles`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  activar(idRol, idNotificacion) {
    return apiClient.post(`${idRol}/notificaciones/${idNotificacion}/activar`)
  },

  estado(idRol, idNotificacion) {
    return apiClient.get(`${idRol}/notificaciones/${idNotificacion}/estado`)
  },

  desactivar(idRol, idNotificacion) {
    return apiClient.post(`${idRol}/notificaciones/${idNotificacion}/desactivar`)
  },

  notificacionesJSON(idRol,params) {
    params = params || {}
    return apiClient.get(`${idRol}/notificaciones.json`, { params: params })
  }
}
